import { render, staticRenderFns } from "./CalendarTest.vue?vue&type=template&id=708cdc02&scoped=true"
import script from "./CalendarTest.vue?vue&type=script&lang=js"
export * from "./CalendarTest.vue?vue&type=script&lang=js"
import style0 from "./CalendarTest.vue?vue&type=style&index=0&id=708cdc02&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "708cdc02",
  null
  
)

export default component.exports